import React from 'react';


const tabs = [
  { id: 'bomkalkulator', label: 'Bomkalkulator', icon: '🧮', desc: 'Presis kostnadsberegning' },
  { id: 'ruteoptimalisering', label: 'Ruteoptimalisering', icon: '🗺️', desc: 'AI-drevet ruteplanlegging' },
  { id: 'flatestyring', label: 'Flåtestyring', icon: '🚛', desc: 'Komplett flåteadministrasjon' },
];

const ServicesHero = ({ activeTab, onTabChange }) => {
  const scrollToSection = (id) => {
    onTabChange(id);
    const el = document.getElementById(id);
    if (el) el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section style={{ padding: '80px 24px 0', maxWidth: '1200px', margin: '0 auto' }}>
      {/* Geometric accent */}
      <div style={{ position: 'absolute', top: '80px', right: '0', width: '300px', height: '300px', border: '1px solid rgba(255,87,34,0.06)', borderRadius: '2px', transform: 'rotate(15deg)', pointerEvents: 'none' }} />
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '20px', marginBottom: '48px' }}>
        <div style={{ width: '4px', height: '64px', background: 'linear-gradient(180deg, #FF5722 0%, #004F98 100%)', flexShrink: 0, marginTop: '4px' }} />
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
            <span style={{ fontFamily: 'var(--font-heading)', fontSize: '11px', fontWeight: 600, letterSpacing: '0.16em', textTransform: 'uppercase', color: '#FF5722' }}>Tjenesteoversikt</span>
            <div style={{ width: '60px', height: '1px', background: 'rgba(255,87,34,0.3)' }} />
          </div>
          <h1 style={{ fontFamily: 'var(--font-heading)', fontSize: 'clamp(28px, 5vw, 42px)', fontWeight: 700, color: 'var(--color-foreground)', letterSpacing: '0.02em', marginBottom: '16px', lineHeight: 1.15 }}>
            Profesjonelle verktøy
            <span style={{ display: 'block', color: 'rgba(224,228,232,0.35)', fontSize: '0.6em', fontWeight: 400, letterSpacing: '0.08em' }}>— for smarte veivalg</span>
          </h1>
          <p style={{ fontFamily: 'var(--font-body)', fontSize: '16px', fontWeight: 400, color: 'var(--color-muted-foreground)', lineHeight: 1.7, maxWidth: '560px' }}>
            Utforsk Veiassistents komplette tjenestepakke — fra presis bomkalkulator til avansert flåtestyring for bedrifter.
          </p>
        </div>
      </div>
      {/* Tab navigation */}
      <div style={{ display: 'flex', gap: '0', borderBottom: '1px solid rgba(224,228,232,0.08)', marginBottom: '0', overflowX: 'auto' }}>
        {tabs?.map((tab) => (
          <button key={tab?.id} onClick={() => scrollToSection(tab?.id)}
            style={{
              background: 'none', border: 'none', borderBottom: activeTab === tab?.id ? '3px solid #FF5722' : '3px solid transparent',
              padding: '16px 28px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '10px',
              transition: 'all 200ms ease', whiteSpace: 'nowrap',
            }}>
            <span style={{ fontSize: '18px' }}>{tab?.icon}</span>
            <div style={{ textAlign: 'left' }}>
              <div style={{ fontFamily: 'var(--font-heading)', fontSize: '13px', fontWeight: activeTab === tab?.id ? 700 : 600, letterSpacing: '0.06em', textTransform: 'uppercase', color: activeTab === tab?.id ? '#FF5722' : 'var(--color-muted-foreground)' }}>{tab?.label}</div>
              <div style={{ fontFamily: 'var(--font-body)', fontSize: '11px', color: 'rgba(224,228,232,0.4)' }}>{tab?.desc}</div>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
};

export default ServicesHero;
